export default "__VITE_ASSET__b98270fd__"